{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2025                                      }
{            Email : info@tmssoftware.com                            }
{            Web : https://www.tmssoftware.com                       }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCEditorDropDownEdit;

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF FMXLIB}
  {$DEFINE FMXVCLLIB}
{$ENDIF}
{$IFDEF VCLLIB}
  {$DEFINE FMXVCLLIB}
  {$DEFINE VCLWEBLIB}
{$ENDIF}
{$IFDEF LCLLIB}
  {$DEFINE LCLWEBLIB}
{$ENDIF}
{$IFDEF WEBLIB}
  {$DEFINE LCLWEBLIB}
  {$DEFINE VCLWEBLIB}
{$ENDIF}

{$IFDEF VCLLIB}
{$HINTS OFF}
{$IF COMPILERVERSION > 34}
{$DEFINE VCLSTYLESENABLED}
{$IFEND}
{$HINTS ON}
{$ENDIF}

interface

uses
  Classes, Types , WEBLib.TMSFNCTypes, WEBLib.Controls, WEBLib.StdCtrls, WEBLib.Forms, WEBLib.TMSFNCEdit, Generics.Collections
  , WEBLib.TMSFNCCustomControl, WEBLib.TMSFNCGraphics, WEBLib.TMSFNCGraphicsTypes, WEBLib.TMSFNCListBox, WEBLib.TMSFNCCalendar, WEBLib.TMSFNCDigitalTimeSelector
  , WEBLib.TMSFNCPopup, SysUtils
  {$IFNDEF LCLLIB}
  , UITypes
  {$ENDIF}
  {$IFDEF LCLLIB}
  , LMessages
  {$ENDIF}
  {$IFDEF VCLLIB}
  , Winapi.Messages, Vcl.ActnList
  {$ENDIF}
  ;

const
  MAJ_VER = 1; // Major version nr.
  MIN_VER = 0; // Minor version nr.
  REL_VER = 0; // Release nr.
  BLD_VER = 0; // Build nr.

  // version history
  // v1.0.0.0 : First Release

type
  TTMSFNCEditorDropDownEditType = (ddetEdit, ddetComboBox, ddetComboEdit, ddetDatePicker, ddetTimePicker);

  TTMSFNCEditorDropDownEditItemTextEvent = procedure(Sender: TObject; AText: string) of object;
  TTMSFNCEditorDropDownEditKeyEvent = procedure(Self: TObject; var Key: Word; Shift: TShiftState) of object;
  TTMSFNCEditorDropDownEditGetFormatSettings = procedure(Sender: TObject; var AFormatSettings: TFormatSettings) of object;

  TTMSFNCEditorDropDownEditAppearance = class(TPersistent)
  private
    FControlFill: TTMSFNCGraphicsFill;
    FEditFont: TTMSFNCGraphicsFont;
    FControlStroke: TTMSFNCGraphicsStroke;
    FEditFill: TTMSFNCGraphicsFill;
    FEditStroke: TTMSFNCGraphicsStroke;
    FControlFont: TTMSFNCGraphicsFont;
    FOnInternalChanged: TNotifyEvent;
    FTransparentEdit: Boolean;
    FListBoxItemHoverFill: TTMSFNCGraphicsFill;
    FListBoxItemHoverFont: TTMSFNCGraphicsFont;
    procedure SetControlFill(const Value: TTMSFNCGraphicsFill);
    procedure SetControlFont(const Value: TTMSFNCGraphicsFont);
    procedure SetControlStroke(const Value: TTMSFNCGraphicsStroke);
    procedure SetEditFill(const Value: TTMSFNCGraphicsFill);
    procedure SetEditFont(const Value: TTMSFNCGraphicsFont);
    procedure SetEditStroke(const Value: TTMSFNCGraphicsStroke);
    procedure SetTransparentEdit(const Value: Boolean);
    procedure SetListBoxItemHoverFill(const Value: TTMSFNCGraphicsFill);
    procedure SetListBoxItemHoverFont(const Value: TTMSFNCGraphicsFont);
  protected
    {$IFDEF VCLLIB}
    procedure ChangeDPIScale(M: Integer; D: Integer);
    {$ENDIF}
    procedure DoFillChanged(Sender: TObject);
    procedure DoFontChanged(Sender: TObject);
    procedure DoStrokeChanged(Sender: TObject);
    procedure DoChanged; virtual;
    property OnInternalChanged: TNotifyEvent read FOnInternalChanged write FOnInternalChanged;
  public
    constructor Create;
    destructor Destroy; override;
    procedure Assign(Source: TPersistent); override;
    property TransparentEdit: Boolean read FTransparentEdit write SetTransparentEdit;
    property EditFill: TTMSFNCGraphicsFill read FEditFill write SetEditFill;
    property EditStroke: TTMSFNCGraphicsStroke read FEditStroke write SetEditStroke;
    property EditFont: TTMSFNCGraphicsFont read FEditFont write SetEditFont;
    property ControlFill: TTMSFNCGraphicsFill read FControlFill write SetControlFill;
    property ControlStroke: TTMSFNCGraphicsStroke read FControlStroke write SetControlStroke;
    property ControlFont: TTMSFNCGraphicsFont read FControlFont write SetControlFont;
    property ListBoxItemHoverFill: TTMSFNCGraphicsFill read FListBoxItemHoverFill write SetListBoxItemHoverFill;
    property ListBoxItemHoverFont: TTMSFNCGraphicsFont read FListBoxItemHoverFont write SetListBoxItemHoverFont;
  end;

  TTMSFNCCustomEditorDropDownEdit = class(TTMSFNCEdit)
  private
    FDateTime: TDateTime;
    FListBoxHoverIndex: Integer;
    FUpdateCount: Integer;
    FPopup: TTMSFNCPopup;
    FListBox: TTMSFNCListBox;
    FCalendar: TTMSFNCCalendar;
    FTimeSelector: TTMSFNCDigitalTimeSelector;
    FDropDownType: TTMSFNCEditorDropDownEditType;
    FDropDownWidth: Integer;
    FDropDownHeight: Integer;
    FDropDownStayOpen: Boolean;
    FOnItemChanged: TTMSFNCEditorDropDownEditItemTextEvent;
    FListBoxItemIndex: Integer;
    FAppearance: TTMSFNCEditorDropDownEditAppearance;
    FOnDropDownClosed: TNotifyEvent;
    FOnDropDownKeyDown: TTMSFNCEditorDropDownEditKeyEvent;
    FOnEditKeyDown: TTMSFNCEditorDropDownEditKeyEvent;
    FOnItemSelected: TTMSFNCEditorDropDownEditItemTextEvent;
    FOnGetFormatSettings: TTMSFNCEditorDropDownEditGetFormatSettings;
    FHideEdit: Boolean;
    FDisableEditKeyInput: Boolean;
    procedure SetDropDownType(const Value: TTMSFNCEditorDropDownEditType);
    function GetItems: TTMSFNCListBoxItems;
    procedure SetItems(Value: TTMSFNCListBoxItems);
    procedure SetAppearance(const Value: TTMSFNCEditorDropDownEditAppearance);
    function GetItemIndex: Integer;
    procedure SetItemIndex(const Value: Integer);
    procedure SetHideEdit(const Value: Boolean);
    procedure SetDisableEditKeyInput(const Value: Boolean);
    {$IFDEF FMXLIB}
    procedure ApplyEditStyleLookup(Sender: TObject);
    {$ENDIF}
  protected
    {$IFDEF VCLLIB}
    {$HINTS OFF}
    {$IF COMPILERVERSION > 30}
    procedure ChangeScale(M, D: Integer; isDpiChange: Boolean); override;
    {$ELSE}
    procedure ChangeScale(M, D: Integer); override;
    {$IFEND}
    {$HINTS ON}
    {$ENDIF}
    procedure ApplyAppearance;
    procedure ResetListBox;
    procedure ResetCalendar;
    procedure ResetTimeSelector;
    procedure DoOnAppearanceChanged(Sender: TObject);
    procedure DoOnListBoxItemClick(Sender: TObject;  AItem: TTMSFNCListBoxItem);
    procedure DoOnCalendarSelectDate(Sender: TObject; ADate: TDate);
    procedure DoOnTimeSelected(Sender: TObject; ATime: TTime);
    procedure DoGetFormatSettings(var AFormatSettings: TFormatSettings); virtual;
    procedure DoOnBeforeDrawItem(Sender: TObject; AGraphics: TTMSFNCGraphics; ARect: TRectF; AItem: TTMSFNCListBoxItem; var AAllow: Boolean; var ADefaultDraw: Boolean);
    procedure DoOnBeforeDrawItemText(Sender: TObject; AGraphics: TTMSFNCGraphics; ARect: TRectF; AItem: TTMSFNCListBoxItem; AText: String; var AAllow: Boolean);
    {$IFDEF FMXLIB}
    procedure KeyDown(var Key: Word; var KeyChar: WideChar; Shift: TShiftState); override;
    procedure KeyUp(var Key: Word; var KeyChar: WideChar; Shift: TShiftState); override;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    procedure KeyDown(var Key: Word; Shift: TShiftState); override;
    procedure KeyUp(var Key: Word; Shift: TShiftState); override;
    procedure KeyPress(var Key: Char); override;
    {$ENDIF}
    {$IFDEF FMXLIB}
    procedure DoOnMouseMove(Sender: TObject; Shift: TShiftState; X, Y: Single);
    {$ENDIF}
    {$IFNDEF FMXLIB}
    procedure DoOnMouseMove(Sender: TObject; Shift: TShiftState; X, Y: Integer);
    {$ENDIF}
    procedure DoOnPopupClose(Sender: TObject);
    {$IFDEF FMXLIB}
    procedure DoOnPopupKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
    procedure DoOnListBoxKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
    {$ENDIF}
    {$IFNDEF FMXLIB}
    procedure DoOnPopupKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure DoOnListBoxKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
    {$ENDIF}
    procedure SelectNextValue;
    procedure SelectPreviousValue;
    procedure DoItemChanged; virtual;
    procedure DoItemSelected; virtual;
    procedure DoDropDownClose; virtual;
    procedure DoDropDownKeyDown(var Key: Word; Shift: TShiftState); virtual;
    procedure DoEditKeyDown(var Key: Word; Shift: TShiftState); virtual;
    property DropDownType: TTMSFNCEditorDropDownEditType read FDropDownType write SetDropDownType;
    property DropDownWidth: Integer read FDropDownWidth write FDropDownWidth default 100;
    property DropDownHeight: Integer read FDropDownHeight write FDropDownHeight default 150;
    property DropDownStayOpen: Boolean read FDropDownStayOpen write FDropDownStayOpen default False;
    property Items: TTMSFNCListBoxItems read GetItems write SetItems;
    property DateTime: TDateTime read FDateTime write FDateTime;
    property ItemIndex: Integer read GetItemIndex write SetItemIndex;
    property Appearance: TTMSFNCEditorDropDownEditAppearance read FAppearance write SetAppearance;
    property HideEdit: Boolean read FHideEdit write SetHideEdit default False;
    property DisableEditKeyInput: Boolean read FDisableEditKeyInput write SetDisableEditKeyInput default False;
    property OnItemChanged: TTMSFNCEditorDropDownEditItemTextEvent read FOnItemChanged write FOnItemChanged;
    property OnItemSelected: TTMSFNCEditorDropDownEditItemTextEvent read FOnItemSelected write FOnItemSelected;
    property OnDropDownClosed: TNotifyEvent read FOnDropDownClosed write FOnDropDownClosed;
    property OnDropDownKeyDown: TTMSFNCEditorDropDownEditKeyEvent read FOnDropDownKeyDown write FOnDropDownKeyDown;
    property OnEditKeyDown: TTMSFNCEditorDropDownEditKeyEvent read FOnEditKeyDown write FOnEditKeyDown;
    property OnGetFormatSettings: TTMSFNCEditorDropDownEditGetFormatSettings read FOnGetFormatSettings write FOnGetFormatSettings;
  public
    constructor Create(AOwner: TComponent); override;
    destructor Destroy; override;
    function GetListBoxItemHeight: Integer;
    procedure Assign(Source: TPersistent); override;
    procedure BeginUpdate; {$IFDEF FMXLIB}override;{$ENDIF}
    procedure EndUpdate; {$IFDEF FMXLIB}override;{$ENDIF}
    procedure OpenDropDown;
    procedure CloseDropDown;
  end;

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsWeb)]
  {$ENDIF}
  TTMSFNCEditorDropDownEdit = class(TTMSFNCCustomEditorDropDownEdit)
  published
    property Appearance;
    property DateTime;
    property Items;
    property ItemIndex;
    property DropDownType;
    property DropDownWidth;
    property DropDownHeight;
    property DropDownStayOpen;
    property HideEdit;
    property DisableEditKeyInput;
    property OnItemChanged;
    property OnItemSelected;
    property OnDropDownClosed;
    property OnDropDownKeyDown;
    property OnEditKeyDown;
    property OnGetFormatSettings;
  end;

implementation

uses
  WEBLib.Graphics, DateUtils, WEBLib.TMSFNCUtils
  {$IFDEF FMXLIB}
  ,FMX.Types, FMX.Objects, FMX.Styles.Objects
  {$ENDIF}
  ;

{ TTMSFNCCustomEditorDropDownEdit }

{$IFDEF FMXLIB}
procedure TTMSFNCCustomEditorDropDownEdit.ApplyEditStyleLookup(Sender: TObject);
var
  ro, obj: TFmxObject;
  r: TRectangle;
begin
  obj := Self.FindStyleResource('background');
  if Assigned(FAppearance) then
  begin

    if Assigned(obj) then
    begin
      if FAppearance.TransparentEdit and (obj is TActiveStyleObject) then
        TActiveStyleObject(obj).Source := nil
      else
      begin
        ro := obj.FindStyleResource('background_new');
        if not Assigned(ro) then
        begin
          ro := TRectangle.Create(obj);
          r := ro as TRectangle;
          r.Align := TAlignLayout.Client;
          r.HitTest := False;
          r.Parent := obj;
          r.StyleName := 'background_new';
        end
        else
          r := ro as TRectangle;

        case FAppearance.EditFill.Kind of
          gfkNone: r.Fill.Kind := TBrushKind.None;
          gfkSolid: r.Fill.Kind := TBrushKind.Solid;
          gfkGradient: r.Fill.Kind := TBrushKind.Gradient;
        end;
        if FAppearance.EditStroke.Kind = gskNone then
           r.Stroke.Kind := TBrushKind.None
        else
          r.Stroke.Kind := TBrushKind.Solid;

        r.Fill.Color := FAppearance.FEditFill.Color;
        r.Fill.Gradient.Color := FAppearance.FEditFill.Color;
        r.Fill.Gradient.Color1 := FAppearance.FEditFill.ColorTo;
        r.Stroke.Color := FAppearance.FEditStroke.Color;
      end;
    end;
  end;
end;

{$ENDIF}

procedure TTMSFNCCustomEditorDropDownEdit.ApplyAppearance;
begin
  {$IFDEF VCLWEBLIB}
  BorderStyle := bsNone;
  {$ENDIF}
  if Assigned(FListBox)  then
  begin
    FListBox.Fill.Assign(FAppearance.ControlFill);
    FListBox.Stroke.Assign(FAppearance.ControlStroke);
    if FListBox.Stroke.Kind <> gskNone then
      FPopup.FillColor := FAppearance.ControlStroke.Color
    else
      FPopup.FillColor := FAppearance.ControlFill.Color;

    FListBox.DefaultItem.TextColor := FAppearance.ControlFont.Color;
    FListBox.ItemsAppearance.Font.Assign(FAppearance.ControlFont);
  end;

  {$IFDEF FMXLIB}
  StyledSettings := StyledSettings - [TStyledSetting.FontColor];
  FontColor := FAppearance.EditFont.Color;
  Font.Size := FAppearance.EditFont.Size;
  Font.Style := FAppearance.EditFont.Style;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  Color := FAppearance.EditFill.Color;
  Font.Color := FAppearance.EditFont.Color;
  {$ENDIF}
end;

procedure TTMSFNCCustomEditorDropDownEdit.Assign(Source: TPersistent);
begin
  if (Source is TTMSFNCCustomEditorDropDownEdit) then
  begin
    FDateTime := (Source as TTMSFNCCustomEditorDropDownEdit).DateTime;
    FListBox.Assign((Source as TTMSFNCCustomEditorDropDownEdit).FlistBox);
    FAppearance.Assign((Source as TTMSFNCCustomEditorDropDownEdit).Appearance);
  end
  else
    inherited;
end;

procedure TTMSFNCCustomEditorDropDownEdit.BeginUpdate;
begin
  Inc(FUpdateCount);
  inherited;
end;

{$HINTS OFF}
{$IFDEF VCLLIB}
{$IF COMPILERVERSION > 30}
procedure TTMSFNCCustomEditorDropDownEdit.ChangeScale(M, D: Integer; isDpiChange: Boolean);
{$ELSE}
procedure TTMSFNCCustomEditorDropDownEdit.ChangeScale(M, D: Integer);
{$IFEND}
begin
  inherited;

  FAppearance.ChangeDPIScale(M, D);
  {$IF COMPILERVERSION >= 33}
  if M <> D then
  begin
    FPopup.ScaleForPPI(M);
    FListBox.ScaleForPPI(M);
    FCalendar.ScaleForPPI(M);
    FTimeSelector.ScaleForPPI(M);
  end;
  {$IFEND}
end;
{$ENDIF}
{$HINTS ON}

procedure TTMSFNCCustomEditorDropDownEdit.CloseDropDown;
begin
  if FPopup.IsOpen then
  begin
    FPopup.IsOpen := False;
    DoDropDownClose;
  end;
end;

constructor TTMSFNCCustomEditorDropDownEdit.Create(AOwner: TComponent);
begin
  inherited;

  FListBoxHoverIndex := -1;
  FListBoxItemIndex := -1;

  FDateTime := Now;

  FDropDownType := ddetEdit;

  FDropDownWidth := 100;
  FDropDownHeight := 150;

  FDropDownStayOpen := False;

  FHideEdit := False;
  FDisableEditKeyInput := False;

  FPopup := TTMSFNCPopup.Create(AOwner);
  FPopup.DragWithParent := True;
  FPopup.OnClosePopup := DoOnPopupClose;
  {$IFDEF FMXLIB}
  OnApplyStyleLookup := ApplyEditStyleLookup;
  {$ENDIF}
  FAppearance := TTMSFNCEditorDropDownEditAppearance.Create;
  FAppearance.OnInternalChanged := DoOnAppearanceChanged;

  FListBox := TTMSFNCListBox.Create(FPopup);
  FListBox.Parent := FPopup;
  FListBox.OnItemClick := DoOnListBoxItemClick;
  FListBox.OnBeforeDrawItem := DoOnBeforeDrawItem;
  FListBox.OnBeforeDrawItemText := DoOnBeforeDrawItemText;
  FListBox.TreeView.OnMouseMove := DoOnMouseMove;
  {$IFNDEF FMXLIB}
  FListBox.AlignWithMargins := True;
  {$ENDIF}
  FListBox.Margins.Top := 1;
  FListBox.Margins.Left := 1;
  FListBox.Margins.Right := 1;
  FListBox.Margins.Bottom := 1;
  FListBox.OnKeyDown := @DoOnListBoxKeyDown;
  FListBox.TreeView.OnKeyDown := @DoOnListBoxKeyDown;

  FCalendar := TTMSFNCCalendar.Create(FPopup);
  FCalendar.Interaction.AllowMonthSelection := True;
  FCalendar.Interaction.AllowYearSelection := True;
  FCalendar.Parent := FPopup;
  FCalendar.Interaction.MultiSelect := False;
  FCalendar.OnSelectDate := DoOnCalendarSelectDate;

  FTimeSelector := TTMSFNCDigitalTimeSelector.Create(FPopup);
  FTimeSelector.Parent := FPopup;
  FTimeSelector.OnTimeSelected := DoOnTimeSelected;

  ResetListBox;
  ResetCalendar;
end;

destructor TTMSFNCCustomEditorDropDownEdit.Destroy;
begin
  FListBox.Free;
  FAppearance.Free;
  FPopup.Free;
  inherited;
end;

procedure TTMSFNCCustomEditorDropDownEdit.DoDropDownClose;
begin
  if Assigned(FOnDropDownClosed) then
    OnDropDownClosed(Self);
end;

procedure TTMSFNCCustomEditorDropDownEdit.DoDropDownKeyDown(var Key: Word; Shift: TShiftState);
begin
  if Assigned(FOnDropDownKeyDown) then
    FOnDropDownKeyDown(Self, Key, Shift);
end;

procedure TTMSFNCCustomEditorDropDownEdit.DoEditKeyDown(var Key: Word; Shift: TShiftState);
begin
  if Assigned(FOnEditKeyDown) then
    FOnEditKeyDown(Self, Key, Shift);
end;

procedure TTMSFNCCustomEditorDropDownEdit.DoGetFormatSettings(var AFormatSettings: TFormatSettings);
begin
  if Assigned(FOnGetFormatSettings) then
    FOnGetFormatSettings(Self, AFormatSettings);
end;

procedure TTMSFNCCustomEditorDropDownEdit.DoItemChanged;
begin
  if Assigned(FOnItemChanged) then
    FOnItemChanged(Self, Text);
end;

procedure TTMSFNCCustomEditorDropDownEdit.DoItemSelected;
begin
  if Assigned(FOnItemSelected) then
    FOnItemSelected(Self, Text);
end;

procedure TTMSFNCCustomEditorDropDownEdit.DoOnAppearanceChanged(Sender: TObject);
begin
  if FUpdateCount <= 0 then
  begin
    ApplyAppearance;
    Invalidate;
  end;
end;

procedure TTMSFNCCustomEditorDropDownEdit.DoOnBeforeDrawItem(Sender: TObject; AGraphics: TTMSFNCGraphics; ARect: TRectF; AItem: TTMSFNCListBoxItem; var AAllow, ADefaultDraw: Boolean);
begin
  if AItem.Index = FListBoxHoverIndex then
    AGraphics.Fill.Assign(FAppearance.FListBoxItemHoverFill);
end;

procedure TTMSFNCCustomEditorDropDownEdit.DoOnBeforeDrawItemText(Sender: TObject; AGraphics: TTMSFNCGraphics; ARect: TRectF; AItem: TTMSFNCListBoxItem; AText: String; var AAllow: Boolean);
begin
  if AItem.Index = FListBoxHoverIndex then
    AGraphics.Font.Assign(FAppearance.FListBoxItemHoverFont);
end;

procedure TTMSFNCCustomEditorDropDownEdit.DoOnCalendarSelectDate(Sender: TObject; ADate: TDate);
var
  fs: TFormatSettings;
begin
  if FDateTime <> ADate then
  begin
    FDateTime := ADate;

    fs := TFormatSettings.Create;
    DoGetFormatSettings(fs);

    Text := DateTimeToStr(ADate, fs);
    DoItemChanged;
  end;

  DoItemSelected;

  if not FDropDownStayOpen then
  begin
    FPopup.IsOpen := False;
    ResetListBox;
  end;
end;

procedure TTMSFNCCustomEditorDropDownEdit.DoOnListBoxItemClick(Sender: TObject;  AItem: TTMSFNCListBoxItem);
begin
  if Text <> AItem.Text then
  begin
    Text := AItem.Text;
    FListBoxItemIndex := AItem.Index;
    DoItemChanged;
  end;

  DoItemSelected;

  if not FDropDownStayOpen then
  begin
    FPopup.IsOpen := False;
    ResetListBox;
  end;
end;
{$IFDEF FMXLIB}
procedure TTMSFNCCustomEditorDropDownEdit.DoOnMouseMove(Sender: TObject; Shift: TShiftState; X, Y: Single);
{$ENDIF}
{$IFNDEF FMXLIB}
procedure TTMSFNCCustomEditorDropDownEdit.DoOnMouseMove(Sender: TObject; Shift: TShiftState; X, Y: Integer);
{$ENDIF}
var
  it: TTMSFNCListBoxItem;
begin
  it := FListBox.XYToItem(X,Y);
  if Assigned(it) then
    FListBoxHoverIndex := it.Index
  else
    FListBoxHoverIndex := -1;

  {$IFDEF FMXLIB}
  FListBox.Invalidate;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FListBox.TreeView.Invalidate;
  {$ENDIF}
end;

{$IFDEF FMXLIB}
procedure TTMSFNCCustomEditorDropDownEdit.DoOnListBoxKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
{$ENDIF}
{$IFNDEF FMXLIB}
procedure TTMSFNCCustomEditorDropDownEdit.DoOnListBoxKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
{$ENDIF}
begin
  DoDropDownKeyDown(Key, Shift);
  inherited;
end;

{$IFDEF FMXLIB}
procedure TTMSFNCCustomEditorDropDownEdit.DoOnPopupKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
{$ENDIF}
{$IFNDEF FMXLIB}
procedure TTMSFNCCustomEditorDropDownEdit.DoOnPopupKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
{$ENDIF}
begin
  DoDropDownKeyDown(Key, Shift);
  inherited;
end;

procedure TTMSFNCCustomEditorDropDownEdit.DoOnPopupClose(Sender: TObject);
begin
  DoDropDownClose;
end;

procedure TTMSFNCCustomEditorDropDownEdit.DoOnTimeSelected(Sender: TObject; ATime: TTime);
var
  fs: TFormatSettings;
begin
  if FDateTime <> ATime then
  begin
    FDateTime := ATime;

    fs := TFormatSettings.Create;
    DoGetFormatSettings(fs);

    Text := TimeToStr(ATime, fs);
    DoItemChanged;
  end;

  DoItemSelected;

  if not FDropDownStayOpen then
  begin
    FPopup.IsOpen := False;
    ResetTimeSelector;
  end;
end;

procedure TTMSFNCCustomEditorDropDownEdit.EndUpdate;
begin
  inherited;
  ApplyAppearance;
  Invalidate;
end;

function TTMSFNCCustomEditorDropDownEdit.GetListBoxItemHeight: Integer;
begin
  Result := 30;
  if Assigned(FListBox) then
    Result := Round(FListBox.ItemsAppearance.FixedHeight);
end;

function TTMSFNCCustomEditorDropDownEdit.GetItemIndex: Integer;
begin
  if Assigned(FListBox) then
    Result := FListBox.ItemIndex
  else
    Result := FListBoxItemIndex;
end;

function TTMSFNCCustomEditorDropDownEdit.GetItems: TTMSFNCListBoxItems;
begin
  Result := FListBox.Items;
end;

{$IFDEF FMXLIB}
procedure TTMSFNCCustomEditorDropDownEdit.KeyDown(var Key: Word; var KeyChar: WideChar; Shift: TShiftState);
{$ENDIF}
{$IFNDEF FMXLIB}
procedure TTMSFNCCustomEditorDropDownEdit.KeyDown(var Key: Word; Shift: TShiftState);
{$ENDIF}
begin
  if (Key = KEY_RETURN) and Assigned(FPopup) then
    FPopup.IsOpen := False;

  DoEditKeyDown(Key, Shift);
    inherited;
end;

{$IFDEF FMXLIB}
procedure TTMSFNCCustomEditorDropDownEdit.KeyUp(var Key: Word; var KeyChar: WideChar; Shift: TShiftState);
{$ENDIF}
{$IFNDEF FMXLIB}
procedure TTMSFNCCustomEditorDropDownEdit.KeyUp(var Key: Word; Shift: TShiftState);
{$ENDIF}
begin
  if not FDisableEditKeyInput then
  begin
    inherited;
  end;

  if Key = KEY_DOWN then
    SelectNextValue
  else if Key = KEY_UP then
    SelectPreviousValue;
end;

{$IFNDEF FMXLIB}
procedure TTMSFNCCustomEditorDropDownEdit.KeyPress(var Key: Char);
begin
  if not FDisableEditKeyInput then
  begin
    inherited;
  end;
end;
{$ENDIF}

procedure TTMSFNCCustomEditorDropDownEdit.OpenDropDown;
begin
  if FDropDownType <> ddetEdit then
  begin
    FPopup.PlacementControl := Self;
    FPopup.VerticalOffset := 2;
    FPopup.StaysOpen := True;

//    if FDropDownType <> ddetComboEdit then
//      Self.Visible := False;

    case FDropDownType of
      ddetComboEdit, ddetComboBox:
      begin
        FPopup.ContentControl := FListBox;
        FListBox.Visible := True;
        FListBox.ItemIndex := FListBoxItemIndex;
      end;
      ddetDatePicker:
      begin
        FPopup.ContentControl := FCalendar;
        FCalendar.Visible := True;
        FCalendar.Date := FDateTime;
      end;
      ddetTimePicker:
      begin
        FPopup.ContentControl := FTimeSelector;
        FTimeSelector.Visible := True;
        FTimeSelector.SelectedTime := EncodeTime(HourOf(FDateTime), MinuteOf(FDateTime), SecondOf(FDateTime), 0);
      end;
    end;

    FPopup.DropDownHeight := FDropDownHeight;
    FPopup.DropDownWidth := FDropDownWidth;
    FPopup.IsOpen := True;
    FPopup.Popup(False);
  end
  else
    Self.SetFocus;

  if not FHideEdit then
  begin
    if not FDisableEditKeyInput then
      FPopup.FocusedControl := Self;

    SelectAll;
    {$IFDEF FMXLIB}
    CaretPosition := Text.Length;
    {$ELSE}
    SelStart := Length(Text);
    {$ENDIF}
  end
  else
    Self.Visible := False;
end;

procedure TTMSFNCCustomEditorDropDownEdit.ResetCalendar;
begin
  if Assigned(FCalendar) then
  begin
    FCalendar.Visible := False;
    FCalendar.Parent := nil;
    {$IFDEF FMXLIB}
    FCalendar.Position.X := -1000;
    FCalendar.Position.Y := -1000;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FCalendar.Left := -1000;
    FCalendar.Top := -1000;
    {$ENDIF}
  end;
end;

procedure TTMSFNCCustomEditorDropDownEdit.ResetListBox;
begin
  if Assigned(FListBox) then
  begin
    FListBox.Visible := False;
    FListBox.Parent := nil;
    FListBox.ItemIndex := -1;
    {$IFDEF FMXLIB}
    FListBox.Position.X := -1000;
    FListBox.Position.Y := -1000;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FListBox.Left := -1000;
    FListBox.Top := -1000;
    {$ENDIF}
    FListBoxHoverIndex := -1;
    FListBoxItemIndex := -1;
  end;
end;

procedure TTMSFNCCustomEditorDropDownEdit.ResetTimeSelector;
begin
  if Assigned(FTimeSelector) then
  begin
    FTimeSelector.Visible := False;
    FTimeSelector.Parent := nil;
    {$IFDEF FMXLIB}
    FTimeSelector.Position.X := -1000;
    FTimeSelector.Position.Y := -1000;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FTimeSelector.Left := -1000;
    FTimeSelector.Top := -1000;
    {$ENDIF}
  end;
end;

procedure TTMSFNCCustomEditorDropDownEdit.SelectNextValue;
var
  idx: Integer;
  t: TTime;
  fs: TFormatSettings;
begin
  if Assigned(FListBox) then
  begin
    idx := FListBox.ItemIndex;
    if idx < 0 then
      FListBox.SelectItem(0)
    else if idx < FListBox.Items.Count then
      FListBox.SelectItem(idx + 1);

    if Assigned(FListBox.SelectedItem) then
    begin
      Text := FListBox.SelectedItem.Text;
      FListBox.ScrollToItem(FListBox.SelectedItem.Index);
    end
    else
      Text := '';
    {$IFDEF FMXLIB}
    CaretPosition := Text.Length;
    {$ELSE}
    SelStart := Length(Text);
    {$ENDIF}
  end
  else if Assigned(FCalendar) then
  begin
    FCalendar.NextDate;

    fs := TFormatSettings.Create;
    DoGetFormatSettings(fs);

    Text := DateTimeToStr(FCalendar.Date, fs)
  end
  else if Assigned(FTimeSelector) then
  begin
    t := FTimeSelector.SelectedTime;
    FTimeSelector.SelectedTime := IncHour(t);

    fs := TFormatSettings.Create;
    DoGetFormatSettings(fs);

    Text := DateTimeToStr(FTimeSelector.SelectedTime, fs)
  end;
end;

procedure TTMSFNCCustomEditorDropDownEdit.SelectPreviousValue;
var
  idx: Integer;
  t: TTime;
  fs: TFormatSettings;
begin
  if Assigned(FListBox) then
  begin
    idx := FListBox.ItemIndex;
    if idx < 0 then
      FListBox.SelectItem(FListBox.Items.Count - 1)
    else if idx > 0 then
      FListBox.SelectItem(idx - 1);

    if Assigned(FListBox.SelectedItem) then
    begin
      Text := FListBox.SelectedItem.Text;
      FListBox.ScrollToItem(FListBox.SelectedItem.Index);
    end
    else
      Text := '';

    {$IFDEF FMXLIB}
    CaretPosition := Text.Length;
    {$ELSE}
    SelStart := Length(Text);
    {$ENDIF}
  end
  else if Assigned(FCalendar) then
  begin
    FCalendar.PreviousDate;
    fs := TFormatSettings.Create;
    DoGetFormatSettings(fs);

    Text := DateTimeToStr(FCalendar.Date, fs)
  end
  else if Assigned(FTimeSelector) then
  begin
    t := FTimeSelector.SelectedTime;
    FTimeSelector.SelectedTime := IncHour(t, -1);
    fs := TFormatSettings.Create;
    DoGetFormatSettings(fs);

    Text := DateTimeToStr(FTimeSelector.SelectedTime, fs)
  end;
end;

procedure TTMSFNCCustomEditorDropDownEdit.SetAppearance(const Value: TTMSFNCEditorDropDownEditAppearance);
begin
  FAppearance.Assign(Value);
  DoOnAppearanceChanged(FAppearance);
end;

procedure TTMSFNCCustomEditorDropDownEdit.SetDisableEditKeyInput(const Value: Boolean);
begin
  FDisableEditKeyInput := Value;
//  Self.Enabled := not FDisableEditKeyInput;
end;
procedure TTMSFNCCustomEditorDropDownEdit.SetDropDownType(const Value: TTMSFNCEditorDropDownEditType);
begin
  if FDropDownType <> Value then
    FDropDownType := Value;
end;

procedure TTMSFNCCustomEditorDropDownEdit.SetHideEdit(const Value: Boolean);
begin
  FHideEdit := Value;
  if Self.Visible and Value then
    Self.Visible := False;
end;

procedure TTMSFNCCustomEditorDropDownEdit.SetItemIndex(const Value: Integer);
begin
  FListBoxItemIndex := Value;
  if Assigned(FListBox) then
    FListBox.ItemIndex := FListBoxItemIndex;
end;

procedure TTMSFNCCustomEditorDropDownEdit.SetItems(Value: TTMSFNCListBoxItems);
begin
  FListBox.Items.Assign(Value);
end;

{ TTMSFNCEditorDropDownEditAppearance }

procedure TTMSFNCEditorDropDownEditAppearance.Assign(Source: TPersistent);
begin
  if (Source is TTMSFNCEditorDropDownEditAppearance) then
  begin
    FEditFill.Assign((Source as TTMSFNCEditorDropDownEditAppearance).EditFill);
    FEditStroke.Assign((Source as TTMSFNCEditorDropDownEditAppearance).EditStroke);
    FEditFont.Assign((Source as TTMSFNCEditorDropDownEditAppearance).EditFont);
    FControlFill.Assign((Source as TTMSFNCEditorDropDownEditAppearance).ControlFill);
    FControlStroke.Assign((Source as TTMSFNCEditorDropDownEditAppearance).ControlStroke);
    FControlFont.Assign((Source as TTMSFNCEditorDropDownEditAppearance).ControlFont);
    FTransparentEdit := (Source as TTMSFNCEditorDropDownEditAppearance).TransparentEdit;
    FListBoxItemHoverFill.Assign((Source as TTMSFNCEditorDropDownEditAppearance).ListBoxItemHoverFill);
    FListBoxItemHoverFont.Assign((Source as TTMSFNCEditorDropDownEditAppearance).ListBoxItemHoverFont);
  end
  else
    inherited;
end;

{$IFDEF VCLLIB}
procedure TTMSFNCEditorDropDownEditAppearance.ChangeDPIScale(M: Integer; D: Integer);
begin
  inherited;
  FEditFont.Height := TTMSFNCUtils.MulDivInt(FEditFont.Height, M, D);
  FControlFont.Height := TTMSFNCUtils.MulDivInt(FControlFont.Height, M, D);
  FListBoxItemHoverFont.Height := TTMSFNCUtils.MulDivInt(FListBoxItemHoverFont.Height, M, D);
end;
{$ENDIF}

constructor TTMSFNCEditorDropDownEditAppearance.Create;
begin
  inherited;
  FTransparentEdit := False;

  FEditFill := TTMSFNCGraphicsFill.Create;
  FEditStroke := TTMSFNCGraphicsStroke.Create;
  FEditFont := TTMSFNCGraphicsFont.Create;
  FControlFill := TTMSFNCGraphicsFill.Create;
  FControlStroke := TTMSFNCGraphicsStroke.Create;
  FControlFont := TTMSFNCGraphicsFont.Create;

  FListBoxItemHoverFill := TTMSFNCGraphicsFill.Create;
  FListBoxItemHoverFont := TTMSFNCGraphicsFont.Create;

  FEditFill.OnChanged := @DoFillChanged;
  FEditFont.OnChanged := @DoFontChanged;
  FEditStroke.OnChanged := @DoStrokeChanged;
  FControlFill.OnChanged := @DoFillChanged;
  FControlFont.OnChanged := @DoFontChanged;
  FControlStroke.OnChanged := @DoStrokeChanged;
  FListBoxItemHoverFill.OnChanged := @DoFillChanged;
  FListBoxItemHoverFont.OnChanged := @DoFontChanged;
end;

destructor TTMSFNCEditorDropDownEditAppearance.Destroy;
begin
  FEditFill.Free;
  FEditStroke.Free;
  FEditFont.Free;
  FControlFill.Free;
  FControlStroke.Free;
  FControlFont.Free;
  FListBoxItemHoverFill.Free;
  FListBoxItemHoverFont.Free;
  inherited;
end;

procedure TTMSFNCEditorDropDownEditAppearance.DoChanged;
begin
  if Assigned(FOnInternalChanged) then
    FOnInternalChanged(Self);
end;

procedure TTMSFNCEditorDropDownEditAppearance.DoFillChanged(Sender: TObject);
begin
  DoChanged;
end;

procedure TTMSFNCEditorDropDownEditAppearance.DoFontChanged(Sender: TObject);
begin
  DoChanged;
end;

procedure TTMSFNCEditorDropDownEditAppearance.DoStrokeChanged(Sender: TObject);
begin
  DoChanged;
end;

procedure TTMSFNCEditorDropDownEditAppearance.SetControlFill(const Value: TTMSFNCGraphicsFill);
begin
  FControlFill.Assign(Value);
  DoFillChanged(FControlFill);
end;

procedure TTMSFNCEditorDropDownEditAppearance.SetControlFont(const Value: TTMSFNCGraphicsFont);
begin
  FControlFont.Assign(Value);
  DoFontChanged(FControlFont);
end;

procedure TTMSFNCEditorDropDownEditAppearance.SetControlStroke(const Value: TTMSFNCGraphicsStroke);
begin
  FControlStroke.Assign(Value);
  DoStrokeChanged(FControlStroke);
end;

procedure TTMSFNCEditorDropDownEditAppearance.SetEditFill(const Value: TTMSFNCGraphicsFill);
begin
  FEditFill.Assign(Value);
  DoFillChanged(FEditFill);
end;

procedure TTMSFNCEditorDropDownEditAppearance.SetEditFont(const Value: TTMSFNCGraphicsFont);
begin
  FEditFont.Assign(Value);
  DoFontChanged(FEditFont);
end;

procedure TTMSFNCEditorDropDownEditAppearance.SetEditStroke(const Value: TTMSFNCGraphicsStroke);
begin
  FEditStroke.Assign(Value);
  DoStrokeChanged(FEditStroke);
end;

procedure TTMSFNCEditorDropDownEditAppearance.SetListBoxItemHoverFill(const Value: TTMSFNCGraphicsFill);
begin
  FListBoxItemHoverFill.Assign(Value);
  DoFillChanged(FListBoxItemHoverFill);
end;

procedure TTMSFNCEditorDropDownEditAppearance.SetListBoxItemHoverFont(const Value: TTMSFNCGraphicsFont);
begin
  FListBoxItemHoverFont.Assign(Value);
  DoFontChanged(FListBoxItemHoverFont);
end;

procedure TTMSFNCEditorDropDownEditAppearance.SetTransparentEdit(const Value: Boolean);
begin
  if FTransparentEdit <> Value then
  begin
    FTransparentEdit := Value;
    DoChanged;
  end;
end;

end.
